import { Button } from 'components/atoms';
import { MagellanPopups } from 'components/molecules';
import { Form } from 'components/organisms';
import {
  artistInitialValues,
  ArtistTabs,
} from 'components/organisms/forms/artist/ArtistForm';
import { useHasPermission } from 'hooks';
import { useParamId } from 'hooks/useParamId';
import middleware from 'middleware';
import { PiPencilSimpleLine } from 'react-icons/pi';
import { useLocation, useNavigate } from 'react-router-dom';
import { useDeleteArtist, useGetArtist } from 'services/artists';
import { STATUS } from 'services/types';
import { getLastPathname } from 'utils/navbar/getParentPathname';
import { onErrorShowToast } from 'utils/service/errorHandler';

const Artist = () => {
  const artistId = useParamId('artist');
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const hasPermission = useHasPermission();

  const getArtist = useGetArtist(artistId);
  const deleteArtist = useDeleteArtist(artistId);

  const onRemoveArtist = async () => {
    await deleteArtist.mutateAsync(undefined, {
      onError: error => onErrorShowToast(error),
      onSuccess: () => navigate('/artist'),
    });
  };

  return (
    <Form.Artist
      i18nextPrefix='artist'
      initialValues={
        getArtist.data
          ? middleware.artist.queryToForm(getArtist.data)
          : artistInitialValues
      }
      onSubmit={() => {}}
      tittle={getArtist.data?.nickname ?? '...'}
      status={{ displayMode: true, isLoading: getArtist.isLoading }}
      disableTabs={[
        ArtistTabs.bio,
        ArtistTabs.actions,
        ...(getArtist.data?.artistStatus !== STATUS.verified
          ? [ArtistTabs.products, ArtistTabs.tracks]
          : []),
      ]}
      topbarContent={
        <div className='flex items-center gap-2'>
          {hasPermission('ArtistPermissionsLIST**', 2) && (
            <Button
              isClear
              onlyIcon
              disabled={!getArtist.data}
              onClick={() => {
                getArtist.data &&
                  navigate(
                    `/artist/edit/${artistId}/${getLastPathname(pathname)}`,
                    {
                      replace: true,
                    }
                  );
              }}>
              <Button.Icon icon={<PiPencilSimpleLine />} />
            </Button>
          )}
          {hasPermission('ArtistPermissionsLIST**', 4) && (
            <MagellanPopups.DeleteWarning
              name={getArtist.data?.nickname}
              onRemove={onRemoveArtist}
            />
          )}
        </div>
      }
    />
  );
};

export default Artist;
